import { ParameterCod } from '@/constants/parameters';
import { useDynamicFavicon } from '@/hooks/useDynamicFavicon';

import { useLayoutConfigContext } from './LayoutConfigContext';

/**
 * Componente que actualiza dinámicamente el favicon basado en el logo de la organización
 * configurado en los parámetros del sistema (ParameterCod.Logo).
 *
 * Este componente no renderiza nada, solo ejecuta el efecto de actualizar el favicon.
 */
const DynamicFavicon = () => {
  const {
    layoutConfig: { parametersDefault },
  } = useLayoutConfigContext();

  // Obtener la URL del logo de la organización
  const logoParam = parametersDefault?.find((x) => x.code === ParameterCod.Logo);
  const logoUrl = logoParam?.character;

  // Actualizar el favicon dinámicamente
  useDynamicFavicon(logoUrl);

  return null;
};

export default DynamicFavicon;
